import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import {
  RouteHandler,
  ShopViewConstants
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import dataAids from '../../../constants/dataAids';
import { mapContextToProps } from '../OlsShopContext';

const getStyles = isSelected => ({
  link: {
    display: 'block',
    pointerEvents: isSelected ? 'none' : 'auto'
  },
  overflow: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  lighter: {
    opacity: 0.7
  }
});

export function CategoryLink(props) {
  const {
    name,
    permalink,
    isSelected,
    onClick,
    isAllProducts = false,
    lighter = false,
    overflowHidden = false,
    desktop = false,
    level = 1,
    getLinkProps
  } = props;
  const { Link } = UX2.Element;
  const params = {};
  const styles = getStyles(isSelected);

  if (isAllProducts) {
    params.routePath = RouteHandler.ALL_PRODUCTS_ROUTE;
  } else {
    params.taxonPermalink = permalink;
  }

  const linkProps = getLinkProps(ShopViewConstants.PRODUCT_LISTING, params);
  const LinkComponent = isSelected ? Link.Active : Link;

  return (
    <LinkComponent
      data-aid={ `${dataAids.CATEGORY_LINK}_${permalink}` }
      onClick={ onClick?.bind(null, permalink, isAllProducts) }
      children={ name }
      href={ linkProps?.href || 'javascript:;' }
      level={ level }
      { ...linkProps }
      style={{
        ...styles.link,
        ...(lighter && !desktop ? styles.lighter : {}),
        ...(overflowHidden ? styles.overflow : {})
      }}
    />
  );
}

CategoryLink.propTypes = {
  name: PropTypes.string,
  permalink: PropTypes.string,
  isSelected: PropTypes.bool,
  isAllProducts: PropTypes.bool,
  isEditMode: PropTypes.bool,
  onClick: PropTypes.func,
  lighter: PropTypes.bool,
  overflowHidden: PropTypes.bool,
  desktop: PropTypes.bool,
  level: PropTypes.number,
  getLinkProps: PropTypes.func
};

export default mapContextToProps(CategoryLink, context => ({
  getLinkProps: context.getLinkProps
}));
